/**
 * Normalizes a designer label or a search term so that punctuation, spacing and
 * accents do not prevent a match (e.g. "CP" finds "C.P. COMPANY").
 * @param {string} value - Designer label or search term.
 * @returns {string} Uppercase value without accents and non alphanumeric characters.
 */
function normalizeDesignerText(value) {
  return (value || '')
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^0-9A-Z]/g, '');
}

function scrollFocus(selector = 0) {
  let scrollPosition = 0;
  if (selector != 0 && $(selector).offset() != undefined) { scrollPosition = $(selector).offset().top - 140; }
  window.scrollTo({ top: scrollPosition, left: 0, behavior: 'smooth' });
}

$(".designers-search").keyup(function () {
  let search = $('.designers-search').val().toUpperCase()
  if (!search) {
    scrollFocus()
    $(".designers-list").removeClass("deactivated-designers");
    $(".designer-item").removeClass("deactivated-designers");
  } else if (search.length == 1) {
    $(".designers-list").addClass("deactivated-designers");
    if (Number.isInteger(parseInt(search))) {
      designerList = document.getElementsByClassName(`initial-0`)
      $(`.designers-list.initial-0-9`).removeClass("deactivated-designers");
      $(`.designer-item.initial-0-9.deactivated-designers`).removeClass("deactivated-designers");
      scrollFocus(`.designers-list.initial-0-9`)
    } else {
      designerList = document.getElementsByClassName(`initial-${search}`)
      $(`.designers-list.initial-${search}`).removeClass("deactivated-designers");
      $(`.designer-item.initial-${search}.deactivated-designers`).removeClass("deactivated-designers");
      scrollFocus(`.designers-list.initial-${search}`)
    }
  } else {
    $(".designers-list").addClass("deactivated-designers");
    let designerItems = []
    if (Number.isInteger(parseInt(search))) {
      designerList = document.getElementsByClassName(`initial-0-9`)
      $(`.designers-list.initial-0-9`).removeClass("deactivated-designers");
      designerItems = document.querySelectorAll(`.designer-item.initial-0-9`)
    } else {
      designerList = document.getElementsByClassName(`initial-${search[0]}`)
      $(`.designers-list.initial-${search[0]}`).removeClass("deactivated-designers");
      designerItems = document.querySelectorAll(`.designer-item.initial-${search[0]}`)
    }
    if (designerItems) {
      const normalizedSearch = normalizeDesignerText(search)
      designerItems.forEach(designerItem => {
        if (normalizeDesignerText(designerItem.innerText).includes(normalizedSearch)) {
          designerItem.classList.remove("deactivated-designers");
          Number.isInteger(parseInt(search)) ? scrollFocus(`.designers-list.initial-0-9`) : scrollFocus(`.designers-list.initial-${search[0]}`)
        } else {
          designerItem.classList.add("deactivated-designers");
        }
      }
      )
      if (Number.isInteger(parseInt(search))) {
        if (designerItems.length === document.querySelectorAll(`.designer-item.initial-0-9.deactivated-designers`).length) {
          $(`.designers-list.initial-0-9`).addClass("deactivated-designers");
          designerItems.forEach(designerItem => {
            designerItem.classList.remove("deactivated-designers");
          }
          )
          scrollFocus()
        }
      } else {
        if (designerItems.length === document.querySelectorAll(`.designer-item.initial-${search[0]}.deactivated-designers`).length) {
          $(`.designers-list.initial-${search[0]}`).addClass("deactivated-designers");
          designerItems.forEach(designerItem => {
            designerItem.classList.remove("deactivated-designers");
          }
          )
          scrollFocus()
        }
      }
    } else scrollFocus()
  }
});